import React from 'react';

export const CommentsIcon = props => (
  <svg width={40} height={32} fill="none" viewBox="0 0 40 32" {...props}>
    <g fillRule="evenodd" clipRule="evenodd">
      <path fill="currentColor" d="M10 14a6 6 0 116 6h-6z" />
      <path
        fill="currentColor"
        d="M19.697 19.945a5.265 5.265 0 005.04 3.74H30V18.42a5.263 5.263 0 00-7.021-4.962 6.996 6.996 0 01-3.281 6.486z"
      />
    </g>
  </svg>
);

export const SearchIcon = props => (
  <svg width={40} height={32} fill="none" viewBox="0 0 40 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 26c5.523 0 10-4.477 10-10S25.523 6 20 6s-10 4.477-10 10 4.477 10 10 10zm-.46-15a4.54 4.54 0 102.404 8.393L24.8 22.45 26.25 21l-2.857-3.056A4.54 4.54 0 0019.54 11zm-2.49 4.54a2.49 2.49 0 114.98 0 2.49 2.49 0 01-4.98 0z"
      clipRule="evenodd"
    />
  </svg>
);

export const DeployIcon = props => (
  <svg width={40} height={32} fill="none" viewBox="0 0 40 32" {...props}>
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M19.86 12.19l4.057-4.057c1.586-1.586 5.289-2.896 6.568-1.617s-.058 4.955-1.644 6.54l-4.056 4.057c-.34.34-.318.895-.152 1.347.997 2.718-3.89 7.541-3.89 7.541l-1.95-1.948 1.83-2.779-1.83.83-3.896-3.897.803-1.857-2.751 1.857L11 16.26s4.8-4.91 7.514-3.917c.451.165 1.007.187 1.347-.153z"
        clipRule="evenodd"
      />
      <path d="M13.608 25.29a2.178 2.178 0 10-2.643-2.635L10 26.259z" />
    </g>
  </svg>
);

export const ExplorerIcon = props => (
  <svg width={40} height={32} fill="none" viewBox="0 0 40 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 7a1 1 0 011-1h7v6h6v13a1 1 0 01-1 1H14a1 1 0 01-1-1zm9-1l5 5h-5z"
      clipRule="evenodd"
    />
  </svg>
);

export const ServerIcon = props => (
  <svg width={40} height={32} fill="none" viewBox="0 0 40 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.922 7a.922.922 0 00-.922.922v3.156c0 .51.413.922.922.922h18.156c.51 0 .922-.413.922-.922V7.922A.922.922 0 0029.078 7zm.578 1a.5.5 0 000 1h7a.5.5 0 000-1zm-.578 5a.922.922 0 00-.922.922v3.156c0 .51.413.922.922.922h18.156c.51 0 .922-.413.922-.922v-3.156a.922.922 0 00-.922-.922zm.846.857a.5.5 0 100 1h7a.5.5 0 100-1zM10 19.922c0-.51.413-.922.922-.922h18.156c.51 0 .922.413.922.922v3.156c0 .51-.413.922-.922.922H10.922a.922.922 0 01-.922-.922zm1 .578a.5.5 0 01.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5z"
      clipRule="evenodd"
    />
  </svg>
);

export const GithubIcon = props => (
  <svg width={40} height={32} fill="none" viewBox="0 0 40 32" {...props}>
    <path
      fill="currentColor"
      d="M17.242 26.224c-.08 0-.169-.008-.267-.026l.04-.446h.396a.39.39 0 00.159-.086.426.426 0 00.125-.241.561.561 0 00.008-.1c0-.242-.003-.468-.006-.771l-.013-1.25c-3.617.668-4.466-1.893-4.5-2.003-.579-1.467-1.371-1.84-1.373-1.841l-.03-.017c-1.826-1.254.21-1.231.217-1.231h.014c1.426.099 2.188 1.424 2.23 1.498.434.749.968 1.117 1.499 1.269.77.22 1.544-.005 2.002-.197.063-.379.167-.706.297-.984.088-.187.188-.352.295-.495-1.382-.196-2.768-.597-3.85-1.514-1.203-1.017-2.019-2.652-2.023-5.314a5.683 5.683 0 01.359-2.036c.23-.607.564-1.152.98-1.634a4.422 4.422 0 01-.227-1.154c-.044-.645.025-1.487.402-2.453l.009-.018s.164-.141.396-.154c.153-.008.385 0 .697.063.608.123 1.54.462 2.826 1.325a12.308 12.308 0 011.563-.317 13.052 13.052 0 013.492-.005c.532.071 1.057.175 1.566.312 2.581-1.744 3.772-1.362 3.776-1.361l.104.031.04.102c.382.966.454 1.806.412 2.45a4.438 4.438 0 01-.223 1.155c.418.48.753 1.023.984 1.63.235.614.363 1.293.364 2.037.004 2.669-.808 4.306-2.009 5.323-1.081.916-2.467 1.317-3.852 1.513.163.213.309.476.423.789.153.42.25.934.251 1.54.002 1.082-.004 2.208-.009 2.953l-.002.748c0 .034.003.07.01.108.018.09.057.176.125.237.037.034.084.061.143.08l.42-.002.042.446c-.1.02-.194.029-.282.03-.086 0-.165-.01-.237-.025l-7.532.013c-.071.015-.148.023-.23.023z"
    />
  </svg>
);

export const InfoIcon = props => (
  <svg width={40} height={32} fill="none" viewBox="0 0 40 32" {...props}>
    <path
      fill="currentColor"
      d="M20.54 25a.681.681 0 00.158-.074l6.174-3.69c.734-.438 1.128-.885 1.128-2.084v-6.444c0-.248-.016-.447-.063-.629l-7.397 4.434zm-8.477-12.921l7.397 4.434V25a.514.514 0 01-.15-.074l-6.182-3.69c-.726-.438-1.128-.885-1.128-2.084v-6.444c0-.248.016-.447.063-.629zM20.004 7c.443 0 .9.143 1.359.406l.068.04 5.567 3.326c.155.088.284.177.394.282l.04.04-7.428 4.426-7.436-4.425c.11-.109.233-.198.378-.286l.063-.037 4.07-2.442h.002l1.488-.883c.434-.262.868-.415 1.296-.443l.071-.003z"
    />
  </svg>
);

export const LiveIcon = props => (
  <svg width={40} height={32} fill="none" viewBox="0 0 40 32" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path d="M15.222 19.113c2.193 0 3.976-2.108 4.023-4.533a.981.981 0 00.178-.48.92.92 0 00-.202-.698c-.114-2.225-.684-4.592-3.033-4.876l-.027-.003c-.681-.083-2.23-.27-2.548.665-2.144-.26-2.41 2.012-2.425 3.889-.248.153-.378.513-.297.886a.944.944 0 00.308.528c.005 2.463 1.804 4.622 4.023 4.622zm1.775 7.354c-.016-2.005-.032-4.022 2.003-5.304C17.645 18.895 5.439 19.5 8.487 27H17l-.003-.533z" />
      <path d="M30.348 13.247c0 1.05-.374 2.087-.816 2.878-.1.179.08.482.262.786.199.333.398.667.226.839-.47.47-1.582.414-2.482.347-.59.517-1.303.819-2.07.819-.861 0-1.654-.382-2.284-1.022l-.514.24c-1.337-.177-2.162-2.377-1.844-4.914.319-2.537 1.66-4.45 2.997-4.272.307.065.584.15.835.251.575-.474 1.257-.75 1.988-.75 2.045 0 3.702 2.148 3.702 4.798zM18.602 26.85h13.36s.965-6.448-6.76-6.617c-7.726-.168-6.6 6.617-6.6 6.617z" />
    </g>
  </svg>
);
export const SettingsIcon = props => (
  <svg width={40} height={32} fill="none" viewBox="0 0 40 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.253 6h-3.076l-.463 1.85a8.413 8.413 0 00-2.13.931l-1.567-.94-2.176 2.176.94 1.567a8.414 8.414 0 00-1.01 2.435L10 14.462v3.077l1.772.442c.209.872.553 1.692 1.01 2.435l-.94 1.567 2.175 2.176 1.566-.94c.744.456 1.564.8 2.436 1.01L18.46 26h3.077l.443-1.772a8.411 8.411 0 002.435-1.01l1.567.94 2.176-2.175-.94-1.567c.456-.743.8-1.563 1.01-2.435L30 17.538v-3.077l-1.772-.442a8.411 8.411 0 00-1.01-2.436l.94-1.566-2.175-2.176-1.567.94a8.408 8.408 0 00-2.736-1.076zM20 20.286a4.286 4.286 0 100-8.572 4.286 4.286 0 000 8.572z"
      clipRule="evenodd"
    />
  </svg>
);
